import { colors } from '../../theme/cssVariables'

const CornerLinesSmall = ({ color = colors.colorA1, width = '102', strokeWidth = '1.5' }) => {
  // const radio = 88 / 102
  // const height = useMemo(() => {
  //   if (width.includes('%')) {
  //     return `${radio * parseInt(width)}%`
  //   }
  //   return `${radio * parseInt(width)}px`
  // }, [])
  return (
    <svg width={width} color={color} strokeWidth={strokeWidth}>
      <use href={`#CornerLinesSmall`} />
    </svg>
  )
}

export default CornerLinesSmall
